export default __webpack_public_path__ + "eeccf4f66002c6f2ba24d3d22f2434c2.woff";